import {initReactI18next, useTranslation} from "react-i18next"
import React, {useState} from "react"
import ApiService from "@bodeboca/api"
import InsightsUtils from "@bodeboca/algolia/utils/insights"
import {use} from "i18next"
import CommonUtils from "@bodeboca/utils"

type Props = {
    productId: number;
    title: string;
    sendEvent: any;
    queryID: any;
    hit: any;
    buttonClass: string
};


use(initReactI18next)
  .init(CommonUtils.i18NConfig())
  .then(() => {
    // I18N Loaded.
  })

const AddToCart = ({productId, title, sendEvent = undefined, queryID = undefined, hit = undefined, buttonClass = ''}: Props) => {
  const [amount, setAmount] = useState(1)

  function increment() {
    setAmount(amount + 1)
  }

  function decrement() {
    if (amount >= 2) setAmount(amount - 1)
  }

  function addToCart() {

    InsightsUtils.getQueryId()
    ApiService.addToCart(productId, amount, title , queryID ?? undefined)

    if(sendEvent !== undefined && hit !== undefined) {
      sendEvent("conversion", hit, "Added to cart after search (list)", {
        eventSubtype: "addToCart",
      })
    }
    else {
      if (queryID !== undefined) {
        InsightsUtils.addedToCartObjectIDsAfterSearch(productId + '')
      } else {
        InsightsUtils.addedToCartObjectIDs(productId + '')
      }

    }
  }


  const {t} = useTranslation()

  return (<div className="add-to-cart">
    <div className="quantity-whole-formato-wrapper">
      <div className="quantity-whole-wrapper">
        <input
          className="minus"
          defaultValue="-"
          type="button"
          onClick={decrement}/>
        <div className="form-item form-item-textfield">
          <div className="hidden text-entered js-processed">Quantity
          </div>
          <input
            className="form-text quantity"
            data-nid={productId}
            maxLength={3}
            size={60}
            type="text"
            value={amount}
            onChange={(e) => {
              setAmount(e.target.value)
            }}/>
        </div>
        <input
          className="plus"
          defaultValue="+"
          type="button"
          onClick={increment}/>
      </div>
    </div>
    <div className="submit-wrapper">
      <img
        alt="Carrito de la compra"
        height="17"
        src="/themes/custom/bodeboca/fonts/svg/cesta.svg"
        width="26"/>
      <input
        className={"node-add-to-cart ajax-cart-submit-form-button bb-button radiocanadabigbutton form-submit " + buttonClass}
        type="button"
        value={t("Add to cart")}
        onClick={addToCart}/>
    </div>
  </div>)
}
export default AddToCart
